var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('GlobalSidebar', {
    attrs: {
      "companies": _vm.companies
    }
  }), _c('div', {
    ref: "contentDiv",
    staticClass: "main-content",
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "id": "content"
    }
  }, [_c('dash-header'), _c('div', {
    staticClass: "inner-content",
    staticStyle: {
      "overflow-x": "hidden",
      "overflow-y": "auto"
    }
  }, [_c('router-view')], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }